import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import {BrowserRouter} from 'react-router-dom';
import { AuthProvider } from './components/Auth/AuthContext';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';

ReactDOM.render(
    <BrowserRouter>
        <AuthProvider>
            <App/>
        </AuthProvider>
    </BrowserRouter>,
    document.getElementById('root')
);
